import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
export default function isReadingPaneBottom() {
    return (getUserConfiguration().UserOptions.GlobalReadingPanePositionReact ==
        ReadingPanePosition.Bottom);
}
//# sourceMappingURL=isReadingPaneBottom.js.map